const BRIEF_AFTER_LOGIN_KEY = 'hub-briefing:after-login';

/**
 * Set by the Hub login: the first screen after login briefs even if this device already did today
 * (a new operator on a shared device). Kept out of the briefing hook so the login bundle stays small.
 */
export const markBriefAfterLogin = () => {
  try {
    sessionStorage.setItem(BRIEF_AFTER_LOGIN_KEY, '1');
  } catch {
    // Storage unavailable: the once-a-day briefing still runs.
  }
};

export const takeBriefAfterLogin = () => {
  try {
    const marked = sessionStorage.getItem(BRIEF_AFTER_LOGIN_KEY) === '1';
    sessionStorage.removeItem(BRIEF_AFTER_LOGIN_KEY);
    return marked;
  } catch {
    return false;
  }
};

const OPEN_KEY = 'hub-briefing:open';

/**
 * The operator's briefing is on screen and not yet dismissed: a reload (pull-to-refresh, the phone
 * dropping a backgrounded app, opening Hub from the tray) brings it back with fresh counts.
 */
export const markBriefingOpen = (userId: string | number) => {
  try {
    localStorage.setItem(`${OPEN_KEY}:${userId}`, '1');
  } catch {
    // Without storage the briefing simply does not come back after a reload.
  }
};

export const clearBriefingOpen = (userId: string | number) => {
  try {
    localStorage.removeItem(`${OPEN_KEY}:${userId}`);
  } catch {
    // Nothing to clear.
  }
};

export const isBriefingLeftOpen = (userId: string | number) => {
  try {
    return localStorage.getItem(`${OPEN_KEY}:${userId}`) === '1';
  } catch {
    return false;
  }
};
